var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConectarTablas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70562 17.5852L17.5862 9.70464C17.161 8.98506 16.917 8.1457 16.917 7.24935C16.917 4.57997 19.081 2.41602 21.7503 2.41602C24.4197 2.41602 26.5837 4.57997 26.5837 7.24935C26.5837 9.91873 24.4197 12.0827 21.7503 12.0827C20.854 12.0827 20.0146 11.8387 19.295 11.4135L11.4145 19.2941C11.8397 20.0136 12.0837 20.853 12.0837 21.7493C12.0837 24.4187 9.9197 26.5827 7.25033 26.5827C4.58095 26.5827 2.41699 24.4187 2.41699 21.7493C2.41699 19.08 4.58095 16.916 7.25033 16.916C8.14668 16.916 8.98604 17.16 9.70562 17.5852ZM7.25033 24.166C8.58501 24.166 9.66699 23.084 9.66699 21.7493C9.66699 20.4147 8.58501 19.3327 7.25033 19.3327C5.91564 19.3327 4.83366 20.4147 4.83366 21.7493C4.83366 23.084 5.91564 24.166 7.25033 24.166ZM21.7503 9.66602C23.085 9.66602 24.167 8.58404 24.167 7.24935C24.167 5.91466 23.085 4.83268 21.7503 4.83268C20.4156 4.83268 19.3337 5.91466 19.3337 7.24935C19.3337 8.58404 20.4156 9.66602 21.7503 9.66602Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConectarTablas);
export default __webpack_public_path__ + "static/media/ConectarTablas.74f6a7b388727951e989f319fdf81242.svg";
export { ForwardRef as ReactComponent };